<script setup lang="ts">
import { useCreditSimulatorAnchor } from '~/composables/credit';

import { CREDIT_WHATSAPP_URL } from '../content';

const { scrollToSimulator } = useCreditSimulatorAnchor();
</script>

<template>
	<section
		class="border-t border-[#262626] bg-[#141414] px-6 py-24 text-[#FAFAFA]"
	>
		<div
			class="mx-auto flex max-w-[1240px] flex-wrap items-center justify-between gap-8"
		>
			<div class="min-w-0 flex-[1_1_520px]">
				<h2
					class="m-0 font-[Inter,sans-serif] text-[clamp(30px,3.2vw,44px)] leading-[1.15] font-normal tracking-[-0.02em]"
				>
					Pronto para comparar propostas?
				</h2>
				<p class="mt-4 mb-0 text-[18px] text-[#C9C9C9]">
					Leva 1 minuto. Sem custo e sem compromisso.
				</p>
			</div>
			<div class="flex flex-wrap gap-3">
				<a
					href="#simulador"
					class="inline-flex min-h-14 items-center rounded-xs bg-[#FAFAFA] px-7 text-[17px] font-medium text-black no-underline"
					@click.prevent="scrollToSimulator"
				>
					Simular agora
				</a>
				<a
					:href="CREDIT_WHATSAPP_URL"
					target="_blank"
					rel="noopener noreferrer"
					class="inline-flex min-h-14 items-center rounded-xs border border-[#6A6A6A] px-7 text-[17px] font-medium text-white no-underline"
				>
					Falar no WhatsApp
				</a>
			</div>
		</div>
	</section>
</template>
